import { compareStrings } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/sorters';
import { ColumnKeys } from '../gridComponents/grid-config';
import { ContentControlTrafficExclusion } from '@nirvana/shared/dtos/types/policies/common';
import { getLabelByExclusionItemType } from '../../../../utils/uiSettings/contentControl/content-control.values';

// sort by column type
export function sortByColumn(
  item1: ContentControlTrafficExclusion,
  item2: ContentControlTrafficExclusion,
  columnName: string,
  direction: string
): number {
  switch (columnName) {
    case ColumnKeys.TYPE:
      return compareStrings(
        getLabelByExclusionItemType(item1.type),
        getLabelByExclusionItemType(item2.type),
        direction
      );

    case ColumnKeys.ENTITY:
      return compareStrings(item1.entity, item2.entity, direction);

    case ColumnKeys.REMARKS:
      return compareStrings(item1.remarks, item2.remarks, direction);
  }

  return 0;
}
